module.exports = {
    genData({
        data,
        bkgColor = 'rgba(220,220,220,0.5)',
        borderColor = 'rgba(220,220,220,0.8)',
        hoverBackgroundColor = 'rgba(220,220,220,0.75)',
        hoverBorderColor = 'rgba(220,220,220,1)',
        label = 'borrow number',
    }) {
        return {
            label,
            backgroundColor: bkgColor,
            borderColor,
            hoverBackgroundColor,
            hoverBorderColor,
            data,
        };
    },
    options: (fontColor = 'white', extend = { xAxes: {} }) => ({
        legend: {
            display: false,
        },
        scales: {
            yAxes: [
                {
                    ticks: {
                        fontColor, // this here
                        beginAtZero: true,
                        callback(label) {
                            if (Math.abs(label / 1000) < 1) return label;
                            return `${label / 1000} K`;
                        },
                    },
                    scaleLabel: {
                        display: true,
                        labelString: '1k = 1000',
                    },
                },
            ],
            xAxes: [
                {
                    gridLines: {
                        fontColor, // this here
                        display: false,
                    },
                    ticks: {
                        fontColor,
                    },
                    ...extend.xAxes,
                },
            ],
        },
    }),
    hourLabel: [
        0,
        '',
        '',
        3,
        '',
        '',
        6,
        '',
        '',
        9,
        '',
        '',
        12,
        '',
        '',
        15,
        '',
        '',
        18,
        '',
        '',
        21,
        '',
        23,
    ],
};
